import * as types from './types';

export const setHomeBoxes = (homeBoxes) => ({
  type: types.SET_HOME_BOXES,
  payload: {
    homeBoxes,
  },
});
